module.exports = "/_next/static/images/mines5-e739f08db115d1fefec97932f3a95a3c.jpg";